import {put,takeLatest, call} from 'redux-saga/effects';
import * as cartService from "../../../services/cartService";
import {
    GET_CART,
    GET_CART_SUCCESS,
    GET_CART_ERROR
}
    from "../../actions/cart";

function* getCartaga(action) {
    try {
        const data=yield call(cartService.GetCart,action.payload)
        yield put({
            type: GET_CART_SUCCESS,
            payload: data 
        });

    } catch(error) {
        yield put({
            type: GET_CART_ERROR,error: error.data
        });
    }
}


export function* getCartSagaWatcher() {
    yield takeLatest(GET_CART,getCartaga);
}